import React from 'react';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { makeSelectHaveFourDoors } from 'containers/Ribbon/ShelvesRibbon/selectors';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import DoorsSelector from 'containers/PanesPanel/DoorsSelector';
import {
  selectAllDoorsAction,
  selectAllSidesAction,
} from 'containers/Ribbon/ShelvesRibbon/actions';
import styled from 'styled-components/macro';
// eslint-disable-next-line no-restricted-imports
import MobileColorsPanel from 'containers/PanesPanel/MobileColorsPanel';
import { setColorsPanelAction } from 'containers/Configurator/actions/general';
import SidesSelector from 'containers/PanesPanel/SidesSelector';
import AllSelector from '../../../components/AllSelector';
import { ActivePanel } from '../../Configurator/constants/general';

interface Props {
  showDoors?: boolean;
}

interface StateProps {
  hasFourDoors: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  hasFourDoors: makeSelectHaveFourDoors(),
});

const ColorsMobilePanel = ({ showDoors }: Props) => {
  const dispatch = useDispatch();
  const { hasFourDoors } = useSelector(stateSelector);
  const { t } = useTranslation();

  let bottomAction = false;

  if (hasFourDoors) {
    bottomAction = true;
  }

  return (
    <div>
      <StyledContainer>
        <div className="">
          {showDoors ? <DoorsSelector /> : <SidesSelector />}
        </div>
        <AllSelector
          onClick={() => {
            if (showDoors) dispatch(selectAllDoorsAction());
            else dispatch(selectAllSidesAction());
            dispatch(setColorsPanelAction(ActivePanel.panes));
          }}
        >
          {t('All')}
        </AllSelector>
      </StyledContainer>
      <MobileColorsPanel />
    </div>
  );
};

export default ColorsMobilePanel;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 26rem;
`;
